function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { device } from '../helpers';
var Route = /*#__PURE__*/ function() {
    "use strict";
    function Route() {
        _class_call_check(this, Route);
        _define_property(this, "options", routeOptions);
        _define_property(this, "marker", null);
        _define_property(this, "marker1", null);
        _define_property(this, "route", null);
        _define_property(this, "$els", {
            field: document.querySelector('[data-route-field]'),
            action: document.querySelector('[data-route-action]')
        });
    }
    _create_class(Route, [
        {
            key: "handleCreateMarker",
            value: function handleCreateMarker() {
                var _this_options = this.options, pointTo = _this_options.pointTo, iconTo = _this_options.iconTo;
                this.marker = new ymaps.Placemark(pointTo, {}, {
                    iconLayout: 'default#image',
                    iconImageHref: iconTo,
                    iconImageSize: [
                        45,
                        45
                    ],
                    iconImageOffset: [
                        -22,
                        -22
                    ]
                });
                this.routeMap.geoObjects.add(this.marker);
                this.routeMap.setCenter(pointTo);
                this.marker1 = new ymaps.Placemark([
                    55.847932,
                    37.651378
                ], {}, {
                    iconLayout: 'default#image',
                    iconImageHref: 'assets/img/marker1.svg',
                    iconImageSize: [
                        45,
                        45
                    ],
                    iconImageOffset: [
                        -22,
                        -22
                    ]
                });
                var self = this;
                this.marker1.events.add('mouseenter', function(e) {
                    if (document.documentElement.clientWidth > 768) {
                        self.marker1.options.set({
                            iconImageHref: 'assets/img/marker2.svg',
                            iconImageSize: [
                                175,
                                45
                            ]
                        });
                    }
                });
                this.marker1.events.add('mouseleave', function(e) {
                    if (document.documentElement.clientWidth > 768) {
                        self.marker1.options.set({
                            iconImageHref: 'assets/img/marker1.svg',
                            iconImageSize: [
                                45,
                                45
                            ]
                        });
                    }
                });
                // добавляем обработчик события "click" - при клике меняем изображение обратно
                this.marker1.events.add('click', function(e) {
                    if (document.documentElement.clientWidth > 768) {}
                    self.marker1.options.set('iconImageHref', 'assets/img/marker2.svg'); // изменяем изображение при клике
                });
                this.routeMap.geoObjects.add(this.marker1);
                this.routeMap.setCenter(pointTo);
            }
        },
        {
            key: "handleAddRoute",
            value: function handleAddRoute(from) {
                var pointTo = this.options.pointTo;
                if (this.route) this.handleRemoveRoute();
                this.route = new ymaps.multiRouter.MultiRoute({
                    referencePoints: [
                        from,
                        pointTo
                    ],
                    params: {
                        results: 2,
                        routingMode: 'auto'
                    }
                }, {
                    boundsAutoApply: true,
                    wayPointFinishIconLayout: false
                });
                this.routeMap.geoObjects.add(this.route);
            }
        },
        {
            key: "handleRemoveRoute",
            value: function handleRemoveRoute() {
                this.routeMap.geoObjects.remove(this.route);
                this.route = null;
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                var _this_$els_field, _this_$els_action;
                ymaps.ready(function() {
                    var _this_options = _this.options, zoom = _this_options.zoom, pointTo = _this_options.pointTo;
                    _this.routeMap = new ymaps.Map('route-map', {
                        center: pointTo,
                        zoom: zoom,
                        controls: []
                    });
                    _this.routeMap.behaviors.disable('scrollZoom');
                    if (device.isTouch()) _this.routeMap.behaviors.disable('drag');
                    _this.routeMap.panes.get('ground').getElement().style.filter = 'grayscale(1) brightness(0.75)';
                    _this.handleCreateMarker();
                });
                (_this_$els_field = this.$els.field) === null || _this_$els_field === void 0 ? void 0 : _this_$els_field.addEventListener('keypress', function(event) {
                    if (event.key === 'Enter') {
                        var value = _this.$els.field.value;
                        if (value.length >= 3) _this.handleAddRoute(value);
                    }
                });
                (_this_$els_action = this.$els.action) === null || _this_$els_action === void 0 ? void 0 : _this_$els_action.addEventListener('click', function(event) {
                    event.preventDefault();
                    var value = _this.$els.field.value;
                    if (value.length >= 3) _this.handleAddRoute(value);
                });
            }
        }
    ]);
    return Route;
}();
export default Route;
